// @flow
import React, {Component} from 'react';
import type {Node} from 'react';
import Page from '../../containers/page/page.js';
import {Link} from 'react-router-dom';
import type {StatusType, CourseType, TranslateType} from '../../types.js';
import styles from '../Dashboard/Dashboard.module.css';
import stylesC from '../Courses/Courses.module.css';
import type {ReduxStatusType} from '../../types.js';
import translate from "../../config/text";

type PropsType = {
    status: ReduxStatusType
};

const Courses = () => {
    return(
        <Link className={styles.coursesLink} to='/courses'>
            <div className={styles.coursesButton}>
                <h3>Courses</h3>
            </div>
        </Link>
    )
}

const Resources = () => {
    return(
        <Link className={styles.coursesLink} to='/resources'>
            <div className={styles.coursesButton}>
                <h3>Resources</h3>
            </div>
        </Link>
    )
}

export class Dashboard extends Component<PropsType> {
    t: TranslateType
    constructor(props: PropsType) {
        super(props);
        this.t = translate(this.props.language);
    }

    componentDidMount(){
        this.props.fetchDataWithRedux();
        window.scrollTo(0, 0);
    }
    render(){

        return (
            <Page>
                <div
                    className={`${stylesC.coursesPresentation} ${styles.coursesPresentation}`}>
                    <p className={`${stylesC.welcomeText} fontTisa`}>{this.t('welcome')}</p>
                    <p className={`${stylesC.presentationText} fontTisa`}>{this.t('introduction')}</p>
                </div>

                <div className={styles.dashboardWrapper}>
                    <Courses />
                    {
                        this.props.data !== undefined && this.props.data.length !== 0 ?
                            <Resources /> :
                            null
                    }
                </div>
            </Page>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.js